'use client';

import type { Streamfield } from '@/types';
import * as AccordionPrimitive from '@radix-ui/react-accordion';
import { ChevronDownIcon } from '@radix-ui/react-icons';
import Streamfields from '@streamfields/Streamfields';

type Props = {
  title: string;
  content: Streamfield[];
};

function Accordion(props: Props) {
  const { title, content } = props;

  return (
    <AccordionPrimitive.Item className='accordion' value={title}>
      <AccordionPrimitive.Header className='accordion__header'>
        <AccordionPrimitive.Trigger className='accordion__trigger'>
          <ChevronDownIcon className='accordion__icon' />
          {title}
        </AccordionPrimitive.Trigger>
      </AccordionPrimitive.Header>
      <AccordionPrimitive.Content className='accordion__content' forceMount>
        {content ? <Streamfields fields={content} /> : null}
      </AccordionPrimitive.Content>
    </AccordionPrimitive.Item>
  );
}

export default Accordion;
